import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import i18n from './locale'
import './css/animate.css';
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'animate.css'
import "./assets/iconfont/iconfont.css"

Vue.use(VueVideoPlayer)
ElementUI.Dialog.props.lockScroll.default = false; //Dialog滚动条抖动
Vue.use(ElementUI);

// import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/dist/css/swiper.css'
// import 'fullpage.js/vendors/scrolloverflow'
// import VueFullpage from 'vue-fullpage.js'
// Vue.use(VueFullpage)


//图片懒加载
import VueLazyLoad from 'vue-lazyload'
Vue.use(VueLazyLoad, {
  preLoad: 1,
  error: require('./assets/image/error.jpg'),
  //不要中文暂时注释loading
  loading: (localStorage.getItem('lang') == 'en_US' ) ? require('./assets/otto/lunbo1.png') : require('./assets/otto/lunbo1.png') ,
  // loading: (localStorage.getItem('lang') == 'en_US' ) ? require('./assets/image/m1.png') : require('./assets/idImage/compress_cn/banner1-id.png') ,
  // loading: require('./assets/image/m1.png'),
  // loading: require('./assets/image/banner-loading.gif'),
  attempt: 2,
});

// Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.config.productionTip = false
i18n.locale = localStorage.getItem('lang')

// var browserLanguage = navigator.language || navigator.userLanguage //获取浏览器语言 博士不要暂时注释
// var language = { //处理成符合后台接收的命名格式
//   en: 'en_US',
//   zh: 'zh_CN',
// }

// i18n.locale = language[browserLanguage.substr(0, 2)] || 'en_US' //可以取到浏览器语言，取不到就是英文。 博士不要暂时注释
// i18n.locale = localStorage.getItem('lang') || i18n.locale //第一次走浏览器后面走本地。博士不要暂时注释

import VueScrollTo from 'vue-scrollto';

let scrollOptions = {
  container: "body", //滚动的容器
  duration:500, //滚动时间
  easing: "ease", //缓动类型
  offset: 0, // 滚动时应应用的偏移量。此选项接受回调函数
  force: true, // 是否应执行滚动
  cancelable: true, // 用户是否可以取消滚动
  onStart: false, // 滚动开始时的钩子函数
  onDone: false, // 滚动结束时候的钩子函数
  onCancel: false, // 用户取消滚动的钩子函数
  x: false, // 是否要在x轴上也滚动
  y: true    // 是否要在y轴上滚动
};

Vue.use(VueScrollTo, scrollOptions);

new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
